export default "__VITE_ASSET__D4v$tcvF__"